import { Component, input } from '@angular/core';
import { NgpFocusVisible, NgpHover } from 'ng-primitives/interactions';

export type CardVariant = 'default' | 'blue';

@Component({
  selector: 'joii-card',
  template: ` <ng-content /> `,
  styles: `
    @property --Joii-Card-Width {
      syntax: '<length>';
      inherits: false;
      initial-value: 361px;
    }

    :host {
      background-color: var(--Vetai-Backgrounds--Base);
      width: var(--Joii-Card-Width);
      padding: var(--Vetai-Spacing-3);
      border-radius: var(--Vetai-Radius-2-5);
      display: block;
      border: 1px solid transparent;
      transition: all 0.2s ease-out;
    }
    :host[data-variant='blue'],
    :host[data-variant='blue'][data-hover],
    :host[data-variant='blue'][data-focus-visible],
    :host[data-hover-enabled='true'][data-hover],
    :host[data-focus-visible-enabled='true'][data-focus-visible] {
      background: var(--Vetai-Form_controls--Background_Active);
      border: 1px solid var(--Vetai-Form_controls--Border_Active);
      outline: none;
    }

    :host[data-disabled='true'] {
      cursor: not-allowed;
      user-select: none;
      background: var(--Vetai-Backgrounds--Tint_2);
    }

    :host[data-disabled='true'][data-hover-enabled='true'][data-hover],
    :host[data-disabled='true'][data-focus-visible-enabled='true'][data-focus-visible] {
      border: 1px solid var(--Vetai-Status_packages--Error--Hover);
    }
    :host[data-shadow='true'] {
      box-shadow: var(--Vetai-Elevation-Medium);
    }
    :host[data-full-width='true'] {
      width: 100%;
    }
  `,
  hostDirectives: [{ directive: NgpHover }, { directive: NgpFocusVisible }],
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.data-disabled]': 'disabled()',
    '[attr.data-shadow]': 'shadow()',
    '[attr.data-full-width]': 'fullWidth()',
    '[attr.data-hover-enabled]': 'hover() && !staticSection()',
    '[attr.data-focus-visible-enabled]': 'focusVisible() && !staticSection()',
    '(click)': 'onHostClick($event)',
    '[attr.tabindex]': 'disabled() || staticSection() ? -1 : 0',
  },
})
export class CardComponent {
  variant = input<CardVariant>('default');
  fullWidth = input<boolean>(false);
  shadow = input<boolean>(false);
  staticSection = input<boolean>(false);
  hover = input<boolean>(true);
  focusVisible = input<boolean>(true);
  disabled = input<boolean>(false);

  onHostClick(event: Event): void {
    if (this.disabled()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
